import React from 'react';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

import DueDate from './DueDate';
import { useStateWithLabel } from '../../../utils/DebugUtils';
import Row from '../../tag/Row';
import Span from '../../tag/Span';
import ToolTip from '../../Tooltip';

const MaternityClinicOptions = ({
  currentValue,
  setCurrentValue,
  selectedClinicKey,
  selectedClinic,
  optionRows,
  dueDate,
  setDueDate,
  headerId,
  existingAppointments,
}) => {
  const [showToolTip, setShowToolTip] = useStateWithLabel('', 'showToolTip');

  // TODO: This code is duplicated from ear clinic options in ClinicOptions-component. Find a way to refactor it to a single component.
  return (
    <>
      <DueDate
        dueDate={dueDate}
        setDueDate={setDueDate}
        selectedClinic={selectedClinic}
        selectedClinicKey={selectedClinicKey}
        currentValue={currentValue}
      />
      <h2 className={'subheading-gray required'}>
        <FormattedMessage id={headerId} />
      </h2>
      <form className="ot-form ot-form-maternityultraoptions">
        {!selectedClinic.options ? (
          <Alert message={`${module_id}.options.not.found`} />
        ) : (
          optionRows.map((row, idx) => (
            <Row key={idx} style={{ marginTop: '10px' }}>
              {row.map((option, optionIdx) => {
                const key = selectedClinic.key + '.option.' + option.value;

                return (
                  <div key={key}>
                    <Span len={5} key={key}>
                      <label htmlFor={key} style={{ position: 'relative' }}>
                        <input
                          type="radio"
                          id={key}
                          name={''}
                          value={key}
                          style={{ marginTop: '-2px' }}
                          checked={currentValue.toString() === key}
                          onChange={(ev) => setCurrentValue(ev.target.value)}
                          disabled={isUltraOptionDisabled(
                            option.value,
                            dueDate,
                            existingAppointments
                          )}
                        />
                        <span
                          className="radio-check"
                          style={{ marginTop: '2px' }}
                        />
                        <span className="radio-label radio-label-black">
                          <FormattedMessage id={key} />
                        </span>
                      </label>

                      <div className="ot-tooltip-container" key={key + '.info'}>
                        <button
                          type="button"
                          data-mytip={key + '.info'}
                          key={key + '.info' + 'button'}
                          className="icon-info maternityultra-button"
                          onMouseDown={(event) => {
                            event.preventDefault();
                          }}
                          onClick={() =>
                            !showToolTip
                              ? setShowToolTip(key + '.info')
                              : setShowToolTip('')
                          }
                          onFocus={() => setShowToolTip(key + '.info')}
                          onBlur={() => setShowToolTip(key + '.info')}
                        />
                        <ToolTip
                          show={showToolTip === key + '.info'}
                          key={key + '.info' + 'tooltip'}
                          id={key + '.info'}
                          className="ot-tooltip-info"
                        >
                          <p>
                            <FormattedMessage id={key + '.info'} />
                          </p>
                        </ToolTip>
                      </div>
                    </Span>
                    {optionIdx === 0 && (
                      <Span len={2} key={optionIdx}>
                        <FormattedMessage id={'or'} />
                      </Span>
                    )}
                  </div>
                );
              })}
            </Row>
          ))
        )}
      </form>
    </>
  );
};

const isUltraOptionDisabled = (option, dueDate, existingAppointments) => {
  // These are used to calculate if the client is too late to reserve a type of ultra.
  const ULTRA_CUT_OFF_TIME_IN_DAYS = {
    Y: 190,
    S: 190,
    R: 130,
    R24: 92,
  };

  const daysToSubtract = ULTRA_CUT_OFF_TIME_IN_DAYS[option];
  const cutOffDatetime = moment(dueDate).subtract(daysToSubtract, 'days');
  const isTooLate = !cutOffDatetime.isAfter(); // Defaults to current time.

  // Make sure client only reserves a type of ultra once.
  // Allow only either of Y & S and either of R & R24.
  const isTypeReserved = (option) =>
    !!existingAppointments.find((a) => a.comment === option);

  const isAlreadyReserved =
    option === 'Y' || option === 'S'
      ? isTypeReserved('Y') || isTypeReserved('S')
      : isTypeReserved('R') || isTypeReserved('R24');

  return isTooLate || isAlreadyReserved;
};

export default MaternityClinicOptions;
